/* eslint-disable no-restricted-globals */
import Keycloak from "keycloak-js";
import { keycloakUrl } from "../url";

const keycloakConfig = {
    url: keycloakUrl,
    // url: `https://staging.mamly.de/auth`, local to connect to staging
    realm: "mamlycoach",
    clientId: "coachPortal",
};
const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
